import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
  })
export class base{
  public httpHeaders=  {
    headers: new HttpHeaders({ 'Content-type': 'application/json' })
  };
  public  serverUrl: string ;
    constructor() {
       this.serverUrl = environment.serverUrl
    }
  
}